import { render, staticRenderFns } from "./supplydetail.vue?vue&type=template&id=501a5728&scoped=true&"
import script from "./supplydetail.vue?vue&type=script&lang=js&"
export * from "./supplydetail.vue?vue&type=script&lang=js&"
import style0 from "./supplydetail.vue?vue&type=style&index=0&id=501a5728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501a5728",
  null
  
)

export default component.exports